import * as S from './styles';
import React, { useContext, useEffect, useState } from 'react';

import Check from 'assets/icons/Done.svg';
import Eye from 'assets/icons/Eye.svg';
import Warning from 'assets/icons/Warning.svg';
import BlueClip from 'assets/icons/Anexo-azul.svg';
import GrayClip from 'assets/icons/Anexo-gray.svg';
import { ReactComponent as Notas } from 'assets/icons/ballon_error.svg';
import { ReactComponent as RedNotas } from 'assets/icons/ballon_error_red.svg';

import Button from 'components/Button';
import ImgLabel from 'components/ImgLabel';
import * as CXT from 'context/globalContext';
import { Capitalize, cpfCnpjMask } from 'utils/mask';
import { toast } from 'react-toastify';
import { filter, size, some } from 'lodash';
import { Deals } from 'services/propostas';
import { Dialog, DialogTitle } from '@mui/material';
import SecurityQuestionDialog from '../SecurityQuestionDialog';

export type ListInfo = {
  name: string;
  cpf: string;
  prop: number;
  date: string;
};

export type ListData = {
  contexto: string;
  dataEnvio: string;
  id: number;
  identifier: string;
  nome: string;
  parecer: string;
  status: string;
  usuarioEnvio: string;
};

export type DocListProps = {
  className?: string;
  activeAnexPopUp: (data: ListData) => void;
  activeNotePopUp: (data: ListData) => void;
  activeViewPopUp: (data: ListData, parecer: string) => void;
  dealNumber: string;
  listInfo?: ListInfo;
  listData?: Array<ListData>;
  docStatus?: string;
  readMod?: boolean;
  show: boolean;
  enablePopUpApprovalDocs(): boolean;
  setDocsApprovalData: React.Dispatch<React.SetStateAction<boolean>>;
};

const DocList = ({
  className = '',
  activeAnexPopUp,
  activeNotePopUp,
  activeViewPopUp,
  dealNumber,
  listInfo,
  listData,
  docStatus = '',
  readMod,
  show,
  enablePopUpApprovalDocs,
  setDocsApprovalData,
}: DocListProps) => {
  const globalContext = useContext(CXT.Context);
  const [isSelectingDocs, setIsSelectingDocs] = useState(false);
  const [showingSecurityDialog, setShowingSecurityDialog] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState<number[]>([]);

  const StatusParecer = (status: string) => {
    switch (status) {
      case 'ACCEPTED':
        return 'Aprovado';
      case 'REJECTED':
        return 'Rejeitado';
      case 'IN_ANALYSIS':
        return 'Aguardando';
      default:
        return '';
    }
  };

  const handleFileSelection = (document: any, event: any) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedDocs([...selectedDocs, document.id]);
    } else {
      setSelectedDocs(filter(selectedDocs, (it) => it !== document.id));
    }
  };

  const reprocessFiles = () => {
    globalContext.setIsLoading(true);
    Deals.ReprocessDocs(dealNumber, selectedDocs)
      .then(() => {
        toast.info('Solicitação de reprocessamento realizada com sucesso!');
      })
      .catch((err) => {
        if (err.response.status >= 400 && err.response.status < 500)
          toast.error('Erro ao consultar o servidor.');
        else
          toast.error(
            'Ops! Tivemos um problema ao prosseguir com a sua solicitação. Tente novamente mais tarde e se o problema persistir contate o suporte!'
          );
      })
      .finally(() => globalContext.setIsLoading(false));
  };

  const filesReproccessSecurityCheck = () => {
    setShowingSecurityDialog(true);
  };

  const closeSecurityDialog = () => {
    setShowingSecurityDialog(false);
  };

  const enableFileSelection = () => {
    setIsSelectingDocs(true);
  };

  useEffect(() => {
    if (enablePopUpApprovalDocs() && show) {
      setDocsApprovalData(true);
    }
  }, [listData]);

  if (!show) return null;

  return (
    <S.Wrapper className={className}>
      <S.InfoBox>
        <S.InfoDataBox className="typeI">
          <ImgLabel className="merge" type="person">
            Nome e CPF/CNPJ
          </ImgLabel>
          <label>{!!listInfo?.name && Capitalize(listInfo.name)}</label>
          <label>{!!listInfo?.cpf && cpfCnpjMask(listInfo.cpf)}</label>
        </S.InfoDataBox>
        <S.InfoDataBox className="typeII">
          <ImgLabel className="merge" type="paper">
            Proposta
          </ImgLabel>
          <label>#{!!listInfo?.prop && listInfo.prop}</label>
        </S.InfoDataBox>
        <S.InfoDataBox className="typeII">
          <ImgLabel className="merge" type="data">
            Data Inclusão
          </ImgLabel>
          <label>{!!listInfo?.date && listInfo.date}</label>
        </S.InfoDataBox>
        <S.TitleListBox className="merge">
          <span>DOCUMENTOS</span>
          <label>Pendente</label>
          <label>Enviado</label>
          <label>Visualizar</label>
          <label>Parecer</label>
          <Notas />
          {isSelectingDocs ? <label>Seleção</label> : <label>Anexar</label>}
        </S.TitleListBox>
        <S.HorizontalLine className="merge longer" />
        <S.ListBox className="merge">
          {listData?.map((element, index) => {
            return (
              <React.Fragment key={index}>
                <span>{`${element.nome} - ${element.contexto}`}</span>
                {globalContext.isLoading ? (
                  <div />
                ) : element.status === 'PENDING_SENDING' ? (
                  <S.Img src={Warning} />
                ) : (
                  <S.Img src={Check} />
                )}

                {element.status === 'PENDING_SENDING' ||
                globalContext.isLoading ? (
                  <div />
                ) : element.status === 'SENDING' ? (
                  <S.Img src={Warning} />
                ) : (
                  <S.Img src={Check} />
                )}

                {/* {element.status === 'PENDING_SENDING' ||
                element.status === 'SENDING' ? ( */}
                {element.status === 'PENDING_SENDING' ||
                globalContext.isLoading ? (
                  <div />
                ) : (
                  <S.Img
                    src={Eye}
                    className="clickable"
                    onClick={() => {
                      activeViewPopUp(
                        element,
                        StatusParecer(element.status) ?? ''
                      );
                    }}
                  />
                )}
                {globalContext.isLoading ? (
                  <div />
                ) : (
                  <S.ParecerText className={StatusParecer(element.status)}>
                    {StatusParecer(element.status)}
                  </S.ParecerText>
                )}

                {element.status === 'REJECTED' ? (
                  globalContext.isLoading ? (
                    <div />
                  ) : (
                    <RedNotas
                      className="clickable"
                      onClick={() => !readMod && activeNotePopUp(element)}
                    />
                  )
                ) : (
                  <div />
                )}

                {globalContext.isLoading ? (
                  <div />
                ) : !isSelectingDocs ? (
                  element.status === 'PENDING_SENDING' ? (
                    <S.Img
                      className="clickable"
                      src={readMod ? GrayClip : BlueClip}
                      onClick={() => !readMod && activeAnexPopUp(element)}
                    />
                  ) : (
                    <S.Img src={GrayClip} />
                  )
                ) : (
                  <input
                    type="checkbox"
                    checked={some(selectedDocs, (it) => it === element.id)}
                    onChange={(e) => handleFileSelection(element, e)}
                  />
                )}
                <S.HorizontalLine className="InternMerge" />
              </React.Fragment>
            );
          })}
        </S.ListBox>

        {docStatus === 'CRIADO' ? (
          <S.ButtonBox className="merge">
            <Button disabled marginTop="0px" height="50px">
              Aguarde aprovação de crédito para anexar documentos.
            </Button>
          </S.ButtonBox>
        ) : (
          ''
        )}

        {isSelectingDocs ? (
          <S.ReprocessButtonBox className="merge">
            <S.ReprocessButtonWrapper>
              <Button
                marginTop="0px"
                height="50px"
                onClick={() => setIsSelectingDocs(false)}
              >
                Cancelar
              </Button>
            </S.ReprocessButtonWrapper>
            <S.ReprocessButtonWrapper>
              <Button
                marginTop="0px"
                height="50px"
                onClick={reprocessFiles}
                disabled={size(selectedDocs) === 0}
              >
                Reprocessar
              </Button>
            </S.ReprocessButtonWrapper>
          </S.ReprocessButtonBox>
        ) : (
          <S.ReprocessButtonBox className="merge">
            <S.ReprocessButtonWrapper>
              <Button
                disabled={readMod}
                marginTop="0px"
                height="50px"
                onClick={filesReproccessSecurityCheck}
              >
                Formalização
              </Button>
            </S.ReprocessButtonWrapper>
          </S.ReprocessButtonBox>
        )}
      </S.InfoBox>
      <SecurityQuestionDialog
        open={showingSecurityDialog}
        handleClose={closeSecurityDialog}
        validationSuccess={enableFileSelection}
      ></SecurityQuestionDialog>
    </S.Wrapper>
  );
};

export default DocList;
